// A <input type="datetime-local"> value is a naive "YYYY-MM-DDTHH:mm" string
// with no timezone attached. The browser already interprets it as the
// visitor's own local time when parsing it into a Date - toISOString() just
// captures that same instant as an unambiguous, timezone-independent UTC
// string, so every future reader (any server, any recipient's browser, in
// any timezone) agrees on the exact same real-world moment.
export function localDateTimeToUtcIso(localValue) {
  if (!localValue) return localValue;
  const parsed = new Date(localValue);
  if (Number.isNaN(parsed.getTime())) return localValue;
  return parsed.toISOString();
}

function toLocalDateTimeInputValue(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

// Default value for a datetime-local input, "N days from now" expressed in
// the visitor's own local time. Building this from toISOString() (UTC) and
// slicing it would silently shift the shown default by the browser's UTC
// offset, since datetime-local inputs display whatever string they're given
// as local wall-clock time with no conversion.
export function defaultLocalDateTimeInput(daysFromNow = 7) {
  return toLocalDateTimeInputValue(new Date(Date.now() + daysFromNow * 24 * 60 * 60 * 1000));
}

// Populate a datetime-local input from a stored release_date value for
// editing. Works for both a UTC ISO string (new messages, unambiguous "Z"
// instant) and a legacy naive "YYYY-MM-DDTHH:mm" string (old messages,
// already local, no timezone) - `new Date(...)` parses both correctly, and
// reformatting to local wall-clock time round-trips the legacy format
// unchanged while correctly converting the new format for editing.
export function utcIsoToLocalDateTimeInput(storedValue) {
  if (!storedValue) return '';
  const parsed = new Date(storedValue);
  if (Number.isNaN(parsed.getTime())) return '';
  return toLocalDateTimeInputValue(parsed);
}
